import { graphql } from '../graphql';

export const layerByproductsQuery = graphql(`
  query LayerByproducts($layerId: ID!) {
    layerByproducts(layerId: $layerId) {
      id
      filename
      type
      contentLength
      downloadUrl
      processJobId
      createdAt
    }
  }
`);
